import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TooltipSupportService {
  
  public openOrCloseUserList$: Subject<boolean> = new BehaviorSubject(false);


  setCloseOpenTooltipSupport(state:boolean) {
    this.openOrCloseUserList$.next(state);
  }

  getCloseOpenTooltipSupport() {
    return this.openOrCloseUserList$.asObservable();
  }
}
